export default __webpack_public_path__ + "static/media/File No. 19.1e74dc4e.pdf";